import React from 'react';
import { useTranslation } from "../context/TranslationContext";
import Image from "./Image";
import config from '../config'; 

import { ReactComponent as IconRemove } from "../resources/assets/iconRemove.svg";

import '../styles/PreviewIcon.css';

const PreviewIcon = ({ image, label , slogan, state, onClick, showEnter=false, showBorder=false, onDelete }) => {
  const { t } = useTranslation();

  return (
    <div className={showBorder===true ? 'preview-icon-panel-border' : 'preview-icon-panel' } onClick={onClick}>
        <div className='preview-icon-image'>
            {image ? <Image src={image} smallLoading={true} /> : ""}
        </div>
        <div className='preview-icon-text'>
            <div className='preview-icon-label'>
                {label}
                {state && (<div className="preview-icon-state" style={{ backgroundColor: "var(--"+config.stateColors[state]+")" }} >{t.state[state]}</div>)}
            </div>
            <div className='preview-icon-slogan'>
                {slogan}
            </div>
        </div>
        {onDelete ?  <div className='preview-icon-enter' onClick={onDelete}><IconRemove></IconRemove></div> : ""}
        {showEnter===true ? <div className='preview-icon-enter'>{'>'}</div> : ""}
    </div>
  ); 
};

export default PreviewIcon;